import { render, staticRenderFns } from "./PagamentosEmpresaSetores.vue?vue&type=template&id=82b91f70&scoped=true&"
import script from "./PagamentosEmpresaSetores.vue?vue&type=script&lang=js&"
export * from "./PagamentosEmpresaSetores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b91f70",
  null
  
)

export default component.exports